module.exports = __webpack_public_path__ + "img/dance-tiao-icon3.e1ff5021.png";